import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { SubmissionError } from 'redux-form/immutable';
import { push } from 'react-router-redux';
import { postNoAuth } from '../../utils/request';

import {
  loginRoutine,
  logoutRoutine,
  fetchProfileRoutine, registerRoutine,
} from '../routines';
import { getAccountId } from '../../utils/firebase';
import { showError } from '../actions/dialogs';

import AuthService from '../../utils/AuthService';
import { fetchSaga, saveSaga } from './helper';

// TODO consolidate into common
function parseAuthenticationError(error = {}) {
  const code = error.errorCode || error.code;
  if (!code) {
    return error.message || error;
  }

  switch (code) {
    case 'auth/invalid-user-token':
      return 'Login token is no longer valid. You must sign in again';
    case 'auth/network-request-failed':
      return 'A network error (such as timeout, interrupted connection or unreachable host) has occurred';
    case 'auth/user-not-found':
      return 'Email could not be found';
    case 'auth/wrong-password':
      return 'Incorrect or invalid password';
    case 'auth/operation-not-allowed':
      return 'The selected sign-in method is not supported';
    case 'auth/requires-recent-login':
      return 'You can only complete this operation if you have signed in recently. Please sign in and try again';
    case 'auth/too-many-requests':
      return 'Requests are blocked from this device due to unusual activity. Please try again later';
    case 'auth/user-disabled':
      return 'Your account has been disabled. Please contact your account administrator or help@staza.io if this is not expected.';
    case 'auth/user-token-expired':
      return 'Login token is no longer valid. You must sign in again';
    case 'auth/web-storage-unsupported':
      return 'Your browser does not support web storage or it has been disabled. Please re-enable to continue';
    case 'permission-denied':
      return 'Insufficient permissions or privileges';
    default:
      return 'Unknown authentication error';
  }
}

function login(authResult) {
  return AuthService.getUserInfo(authResult.accessToken)
    .then((profile) => {
      // console.log('auth0 - profile', profile);

      AuthService.setAccessToken(authResult.accessToken);
      AuthService.setIdToken(authResult.idToken);

      AuthService.setProfile(profile); // static method

      return profile;
    });

  // if (error) {
  //   console.error(error);
  //   return reject(error);
  // }

  // return fetch( `${FIREBASE_CONFIG.apiUrl}/v1/auth/exchange/hub`, {
  //   method: 'POST',
  //   headers: {
  //     'Content-Type': 'application/json',
  //     Accept: 'application/json',
  //     Authorization: `Bearer ${authResult.idToken}`,
  //   },
  //   body: JSON.stringify({ date: new Date() }),
  // }).then((resp) => {
  //   if (resp.ok) {
  //     return resp.json();
  //   }
  //
  //   return resp;
  // }).then((resp) => {
  //   return firebaseAuth.signInWithCustomToken(resp.token).then(firebaseAuth.currentUser).then((res) => {
  //     return firebaseAuth.currentUser.getIdToken().then((t) => {
  //       AuthService.setToken(t);
  //       return resolve(res);
  //     });
  //   });
  // }).catch((err) => {
  //   console.log('errrr', err);
  //   reject(new Error(err.message));
  // });
}

function* loginSaga(action) {
  // console.log('loginSaga', action);
  try {
    const user = yield call(login, action.payload);
    // console.log('user, user', user);
    yield put(loginRoutine.success({ user }));
    yield put(push('/account'));
  } catch (e) {
    console.error('Unable to login', e);
    const message = parseAuthenticationError(e);
    yield put(showError('Invalid credentials', message));
    yield put(loginRoutine.failure(new SubmissionError({ error: message })));
  }
}

function* watchLoginSaga() {
  // run fetchDataFromServer on every trigger action
  yield takeEvery(loginRoutine.TRIGGER, loginSaga);
}

// function* fetchUserSaga() {
//   try {
//     const user = yield call(FireBaseTools.fetchUser);
//     if (user) {
//       yield put(fetchUserRoutine.success({ user }));
//       // yield put(fetchRolesRoutine.trigger());
//     } else {
//       throw new Error('Unable to retrieve user');
//     }
//   } catch (e) {
//     console.error('Fetch User Saga', e);
//     yield put(fetchUserRoutine.failure(e));
//     // yield put(push('/login'));
//   }
// }

// function* watchFetchUserSaga() {
//   yield takeLatest(fetchUserRoutine.TRIGGER, fetchUserSaga);
// }

function* watchFetchProfileSaga() {
  yield takeLatest(fetchProfileRoutine.TRIGGER, fetchSaga(fetchProfileRoutine, () => `/v1/profile?accountId=${getAccountId()}`));
}

function* logoutSaga(action) {
  try {
    const resp = yield call(AuthService.logout);
    console.log('logout resp', resp);
    yield put(logoutRoutine.success(resp));

    if (action && action.payload && action.payload.redirect) {
      yield put(push('/login'));
    }
  } catch (e) {
    console.error('Unable to logout', e);
    yield put(logoutRoutine.failure(new SubmissionError({ error: e.message })));
  }
}

function* watchLogoutSaga() {
  // run fetchDataFromServer on every trigger action
  yield takeEvery(logoutRoutine.TRIGGER, logoutSaga);
}

// function* resetPassword(action) {
//   const email = action.payload.get('email');
//   // if (!email) {
//   //   yield put(resetPasswordRoutine.failure(new SubmissionError({ email: 'Invalid email' })));
//   // }
//
//   try {
//     const resp = yield call(FireBaseTools.resetPasswordEmail, email);
//     yield put(resetPasswordRoutine.success(resp));
//   } catch (e) {
//     console.error('Unable to reset password', e);
//     yield put(resetPasswordRoutine.failure(new SubmissionError({ email: e.message })));
//   }
// }

// function* watchResetPasswordSaga() {
//   // run fetchDataFromServer on every trigger action
//   yield takeEvery(resetPasswordRoutine.TRIGGER, resetPassword);
// }

// function register(request) {
//   console.log('register', request);
//
//   // create user
//   const path = '/v1/users';
//   return postNoAuth(path, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       Accept: 'application/json',
//     },
//     body: JSON.stringify(request),
//   }, true).then((resp) => {
//     return resp;
//   }).catch((err) => {
//     console.error('register', err.message, err);
//     throw err;
//   });
// }
//
// function* registerSaga(action) {
//   try {
//     const { values } = action.payload;
//     console.log('values', values.toJS());
//     const user = yield call(register, values.toJS());
//
//     // const account = yield call(resp.json);
//     console.log('user', user);
//
//     yield put(registerRoutine.success(user));
//   } catch (e) {
//     console.error('Unable to register', e);
//     yield put(registerRoutine.failure(new SubmissionError({ error: e.message })));
//   }
// }

function* watchRegisterSaga() {
  yield takeEvery(registerRoutine.TRIGGER,
    saveSaga(registerRoutine,
      () => '/auth/register',
      () => postNoAuth,
      (payload) => payload.values.toJS()
    ));
}

export {
  watchLoginSaga,
  watchFetchProfileSaga,
  watchLogoutSaga,
  // watchResetPasswordSaga,
  watchRegisterSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/authentication.js